import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end mb-3" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  id: "scenario-dashboard",
  class: "card"
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_7 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_8 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_9 = { class: "row mx-auto my-3" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "dashbaord-create-container" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_15 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_16 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_17 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_18 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_19 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_20 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_21 = {
  key: 1,
  class: "row mx-auto my-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScenarioListItem = _resolveComponent("ScenarioListItem")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.author)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
            disabled: _ctx.loading
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(),
            _createElementVNode("span", { class: "d-none d-md-inline" }, "Create New Scenario", -1)
          ]), 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.learner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.scenarioList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Available Scenarios", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioList.slice(_ctx.page_start,_ctx.page_end), (item, index) => {
                      return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                        key: index,
                        scenario: item,
                        "is-learner": _ctx.learner
                      }, null, 8, ["scenario", "is-learner"]))
                    }), 128)),
                    (Object.keys(_ctx.scenarioList).length > 10)
                      ? (_openBlock(), _createBlock(_component_pagination, {
                          key: 0,
                          class: "col-12",
                          items: _ctx.scenarioList,
                          page_start: _ctx.page_start,
                          page_end: _ctx.page_end,
                          onNextPage: _ctx.nextPage,
                          onPreviousPage: _ctx.previousPage,
                          label: 'Scenarios'
                        }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_component_tabs, {
              key: 1,
              options: { useUrlFragment: false },
              "nav-class": "nav nav-pills",
              "nav-item-class": "nav-item col-md-4 col-sm-6 col-xs-12 text-center mb-4",
              "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
              "nav-item-link-active-class": "active"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tab, {
                  prefix: "<h2 class='mt-2'>",
                  suffix: " / <i class='fas fa-clipboard-list text-primary'></i></h4>",
                  name: "Published Scenarios"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                    (_ctx.scenarioList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Published Scenarios", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioList.slice(_ctx.page_start,_ctx.page_end), (item, index) => {
                            return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                              key: index,
                              scenario: item
                            }, null, 8, ["scenario"]))
                          }), 128)),
                          (Object.keys(_ctx.scenarioList).length > 10)
                            ? (_openBlock(), _createBlock(_component_pagination, {
                                key: 0,
                                class: "col-12",
                                items: _ctx.scenarioList,
                                page_start: _ctx.page_start,
                                page_end: _ctx.page_end,
                                onNextPage: _ctx.nextPage,
                                onPreviousPage: _ctx.previousPage,
                                label: 'Scenarios'
                              }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (!_ctx.trainer)
                  ? (_openBlock(), _createBlock(_component_tab, {
                      key: 0,
                      prefix: "<h2 class='mt-2'>",
                      suffix: " / <i class='fas fa-user text-primary'></i></h4>",
                      name: "My Scenarios"
                    }, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "My Scenarios", -1)),
                        (_ctx.myScenarios.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myScenarios, (item, index) => {
                                return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                                  key: index,
                                  scenario: item
                                }, null, 8, ["scenario"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              (_ctx.myScenarios.length === 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "You do not have any scenarios"))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                                disabled: _ctx.loading
                              }, _cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                                _createTextVNode(),
                                _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE A NEW SCENARIO", -1)
                              ]), 8, _hoisted_13)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.trainer)
                  ? (_openBlock(), _createBlock(_component_tab, {
                      key: 1,
                      prefix: "<h2 class='mt-2'>",
                      suffix: " / <i class='fas fa-search text-primary'></i></h4>",
                      name: "Needs Review"
                    }, {
                      default: _withCtx(() => [
                        _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Scenarios Needing Review", -1)),
                        (_ctx.needsReview.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needsReview, (item, index) => {
                                return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                                  key: index,
                                  scenario: item
                                }, null, 8, ["scenario"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[9] || (_cache[9] = [
                              _createElementVNode("div", { class: "col-12" }, [
                                _createElementVNode("div", { class: "dashbaord-create-container" }, [
                                  _createElementVNode("p", null, "There are No Scenarios Needing Review")
                                ])
                              ], -1)
                            ])))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.trainer)
                  ? (_openBlock(), _createBlock(_component_tab, {
                      key: 2,
                      prefix: "<h2 class='mt-2'>",
                      suffix: " / <i class='fas fa-eye text-primary'></i></h4>",
                      name: "In Review"
                    }, {
                      default: _withCtx(() => [
                        _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Scenarios In Review", -1)),
                        (_ctx.inReview.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inReview, (item, index) => {
                                return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                                  key: index,
                                  scenario: item
                                }, null, 8, ["scenario"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[12] || (_cache[12] = [
                              _createElementVNode("div", { class: "col-12" }, [
                                _createElementVNode("div", { class: "dashbaord-create-container" }, [
                                  _createElementVNode("p", null, "There are No Scenarios In Review")
                                ])
                              ], -1)
                            ])))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_tab, {
                  prefix: "<h2 class='mt-2'>",
                  suffix: " / <i class='fas fa-check-circle text-primary'></i></h4>",
                  name: "Approved"
                }, {
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Approved Scenarios", -1)),
                    (_ctx.approved.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approved, (item, index) => {
                            return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                              key: index,
                              scenario: item
                            }, null, 8, ["scenario"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[15] || (_cache[15] = [
                          _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("div", { class: "dashbaord-create-container" }, [
                              _createElementVNode("p", null, "There are No Approved Scenarios")
                            ])
                          ], -1)
                        ])))
                  ]),
                  _: 1
                }),
                _createVNode(_component_tab, {
                  prefix: "<h2 class='mt-2'>",
                  suffix: " / <i class='fas fa-archive text-primary'></i></h4>",
                  name: "Archived"
                }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Archived Scenarios", -1)),
                    (_ctx.archived.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archived, (item, index) => {
                            return (_openBlock(), _createBlock(_component_ScenarioListItem, {
                              key: index,
                              scenario: item
                            }, null, 8, ["scenario"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[18] || (_cache[18] = [
                          _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("div", { class: "dashbaord-create-container" }, [
                              _createElementVNode("p", null, "There are No Archived Scenarios")
                            ])
                          ], -1)
                        ])))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}